import script from "./CompanyDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyDetails.vue?vue&type=script&setup=true&lang=js"

import "./CompanyDetails.vue?vue&type=style&index=0&id=231deccc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-231deccc"]])

export default __exports__